import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import HotDramas from './components/HotDramas';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import StatsSection from './components/StatsSection';
import ArticlePreview from './components/ArticlePreview';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  useEffect(() => {
    document.title = '6080影视 | 电视剧全集免费高清不缓冲在线观看';
  }, []);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '6080影视',
    url: 'https://www.6080ys.com/',
    description: '6080影视专注电视剧全集免费播放，高清不缓冲在线观看，涵盖最新热播剧、经典老剧、高分剧集，流畅播放超清画质，海量免费电视剧每日更新。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.6080ys.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '6080影视',
    url: 'https://www.6080ys.com/',
    logo: 'https://www.6080ys.com/logo.png',
    description: '6080影视专注电视剧全集免费播放，高清不缓冲在线观看，涵盖最新热播剧、经典老剧、高分剧集。',
    foundingDate: '2018',
    email: 'contact@6080ys.com',
    telephone: '400-888-6080',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '北京',
      streetAddress: '北京市朝阳区建国路88号',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '6080影视是完全免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，6080影视平台所有电视剧资源均免费提供在线观看，无需付费或开通会员。',
        },
      },
      {
        '@type': 'Question',
        name: '观看视频需要下载APP吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。6080影视支持网页直接播放，无需下载任何客户端或插件，打开网页即可观看。',
        },
      },
      {
        '@type': 'Question',
        name: '视频播放卡顿怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们采用先进的多线CDN加速技术，一般情况下播放非常流畅。如遇卡顿，可尝试切换播放线路或检查您的网络连接。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <main>
        <HeroSection />
        <HotDramas />
        <CategoryShowcase />
        <LatestUpdates />
        <StatsSection />
        <ArticlePreview />
      </main>
    </>
  );
}